// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"widget-space--scrollable--1Yi1b"};